import React from 'react';
import {
  FaRocket,
  FaLaptopCode,
  FaBriefcase,
  FaChartLine,
  FaCogs,
  FaUsers,
  FaLeaf,
  FaArrowRight,
} from 'react-icons/fa';

const Vision = () => {
  const objectives = [
    {
      icon: <FaLaptopCode />,
      title: 'Digitaliser les activités',
      text: 'Accompagner les entreprises et organisations dans la transformation numérique de leurs processus et services.',
    },
    {
      icon: <FaBriefcase />,
      title: 'Créer des opportunités',
      text: 'Développer des plateformes et des solutions qui connectent les compétences aux opportunités et créent de la valeur.',
    },
    {
      icon: <FaChartLine />,
      title: 'Améliorer la productivité',
      text: 'Fournir des outils technologiques qui permettent de travailler mieux, plus efficacement et de manière durable.',
    },
    {
      icon: <FaCogs />,
      title: 'Simplifier la gestion',
      text: 'Concevoir des solutions claires qui facilitent le pilotage des activités, des ressources et des opérations.',
    },
    {
      icon: <FaUsers />,
      title: 'Connecter les personnes et les services',
      text: 'Créer des ponts entre l\'offre et la demande, les entreprises et les solutions, les besoins et les ressources.',
    },
    {
      icon: <FaLeaf />,
      title: 'Des solutions adaptées au contexte africain',
      text: 'Développer des outils pensés pour les réalités et les besoins locaux, avec un impact social et économique mesurable.',
    },
  ];

  return (
    <section id="vision" className="vision section">
      <div className="vision-bg"></div>
      <div className="container">
        <div className="vision-header">
          <div className="vision-icon">
            <FaRocket />
          </div>
          <span className="section-tag section-tag-light">Notre vision</span>
          <h2 className="vision-title">
            « Mettre l'innovation au service du développement pour construire une Afrique plus
            connectée, productive et accessible. »
          </h2>
          <p className="vision-subtitle">
            Livia Tech transforme les idées, les compétences et les besoins réels en solutions concrètes
            capables de créer de la valeur et des opportunités. Nous intervenons à la croisée de la technologie,
            de l'ingénierie, du numérique, de l'agriculture, de l'IBTP et du développement social.
          </p>
        </div>

        <div className="vision-grid">
          {objectives.map((objective, index) => (
            <div className="vision-card" key={index}>
              <div className="vision-card-icon">{objective.icon}</div>
              <h3>{objective.title}</h3>
              <p>{objective.text}</p>
            </div>
          ))}
        </div>

        <div className="vision-cta">
          <p>Vous avez un projet en tête ? Parlons-en.</p>
          <a href="#contact" className="btn btn-light btn-lg">
            Discutons de votre projet <FaArrowRight className="btn-icon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Vision;